module.exports = __webpack_public_path__ + "static/media/skck.569de6ee.jpg";